
import firebase from '../lib/firebase';
import useApi from './useApi';

const useSocialLogin = (props = {}) => {
  const { callback } = props;
  const { actions } = useApi();

  const loginWithFacebook = async () => {
    const { user } = await firebase.loginWithFacebook();
    const { accessToken, email, emailVerified } = user;

    return actions.socialLogin({
      firebaseAccessToken: accessToken,
      email,
      emailVerified,
      provider: 'facebook'
    }, callback);
  };

  const loginWithGoogle = async () => {
    const { user } = await firebase.loginWithGoogle();

    const { accessToken, email, emailVerified } = user;

    return actions.socialLogin({
      firebaseAccessToken: accessToken,
      email,
      emailVerified,
      provider: 'google'
    }, callback);
  };

  return { loginWithFacebook, loginWithGoogle };
};

export default useSocialLogin;